import { useState } from "react";

interface ConsentDetails {
  id?: any;
  itemName?: any;
  imageUrl?: any;
  [key: string]: any;
}

interface UseConsentReturn {
  isOpenConsent: boolean;
  constentDetails: ConsentDetails;
  openConsent: () => void;
  closeConsent: () => void;
  updateDetails: (_: any) => void;
}

const useConsent = (): UseConsentReturn => {
  const [isOpenConsent, setIsOpenConsent] = useState(false);
  const [constentDetails, setConstentDetails] = useState<ConsentDetails>({});

  const openConsent = () => setIsOpenConsent(true);
  const closeConsent = () => setIsOpenConsent(false);
  const updateDetails = (_: any) => setConstentDetails((st) => ({ ...st, ..._ }));

  return {
    isOpenConsent,
    constentDetails,
    openConsent,
    closeConsent,
    updateDetails,
  };
};

export default useConsent;
